import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './component/navbar/navbar';
import AppRoutes from './routes/routes';
import { LoaderProvider, useLoader } from './context/loaderContext';
import { SnackbarProvider } from './context/snackbarContext';
import { setLoaderCallbacks } from './apiClient/api';
import { UserDetailProvider } from 'context/userDetailContext';
import { HotelGenericProvider } from 'context/HotelGenericContext';
import { QuotationProvider } from 'context/quotationContext';
import { AgencyAgentProvider } from 'context/agencyAgentContext';
import { ListFilterProvider } from 'context/listFilterContext';
const AppContent: React.FC = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const { showLoader, hideLoader } = useLoader();

  // Set up axios loader callbacks
  useEffect(() => {
    setLoaderCallbacks({ showLoader, hideLoader });
  }, [showLoader, hideLoader]);


  return (
    <div className="App">
      {!isLoginPage && <Navbar />}
      <div className={isLoginPage ? '' : 'app-content'}>
        <AppRoutes />
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <LoaderProvider>
      <SnackbarProvider>
        <UserDetailProvider>
        <HotelGenericProvider>
          <QuotationProvider>
            <AgencyAgentProvider>
              <ListFilterProvider>
                <Router>
                  <AppContent />
                </Router>
              </ListFilterProvider>
            </AgencyAgentProvider>
          </QuotationProvider>
        </HotelGenericProvider>
        </UserDetailProvider> 
      </SnackbarProvider>
    </LoaderProvider>
  );
};

export default App;

